
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { UserClient } from '@/api'
import _ from 'lodash'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
  private changePasswordFormVisible = false
  private data = { oldpassword: '', newpassword: '', confirmpassword: '' }
  private userClient = new UserClient()
  private rules: any

  private validatePass2 = (rule:any, value:any, callback:any) => {
    if (_.isEmpty(value) || _.isNil(value)) {
      callback(new Error('请再次输入密码'))
    } else if (value !== this.data.newpassword) {
      callback(new Error('两次输入密码不一致!'))
    } else {
      callback()
    }
  }

  public constructor() {
    super()
    this.rules = {
      oldpassword: [
        { required: true, message: '旧密码不能为空', trigger: 'blur' },
        { min: 6, max: 10, message: '长度在 6 到 10 个字符', trigger: 'blur' }],
      newpassword: [{ required: true, message: '新密码不能为空', trigger: 'blur' },
        { min: 6, max: 10, message: '新密码长度在 6 到 10 个字符', trigger: 'blur' }],
      confirmpassword: [{ required: true, message: '确认密码不能为空', trigger: 'blur' },
        { min: 6, max: 10, message: '新密码长度在 6 到 10 个字符', trigger: 'blur' },
        { validator: this.validatePass2, trigger: 'blur' }]
    }
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    return UserModule.avatar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    await UserModule.LogOut()
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }

  private async changePassword() {
    this.changePasswordFormVisible = true
  }

  private async hanlderChangePassword() {
    try {
      await this.userClient.password(this.data)
      this.changePasswordFormVisible = false
      this.$notify({
        title: '成功',
        message: '修改密码成功',
        type: 'success',
        duration: 2000
      })
    } catch (e) {
      this.$message({
        type: 'error',
        message: e
      })
    }
  }
}
